

export const index = 8;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/docs/user-guide/custom-panels/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/8.BmJTkgSu.js","_app/immutable/chunks/mtF927Wn.js","_app/immutable/chunks/C8t-7i39.js","_app/immutable/chunks/IHki7fMi.js"];
export const stylesheets = ["_app/immutable/assets/8.D7GVuUQF.css"];
export const fonts = [];
